import { CompanyAdminLayout, MainLayout } from "layouts";
import { ModeratorRoutesPrivileges } from "modules/common";
import { LoginPage, CompanyManagerLoginPage } from "pages/auth";
import { NotFoundPage } from "pages/common";
import NoAccessPage from "pages/common/NoAccessPage/NoAccessPage";
import {
  DashboardPage,
  CategoriesPage,
  ProductsPage,
  ProductCategoryPage,
  CategoryUsageGuidePage,
  InventoryPage,
  TransfersPage,
  TransferDetailPage,
  DeliveryRulesPage,
  CreateProductPage,
  ProductInfoPage,
  EditProductPage,
  VerificationPage,
  ContentPage,
  StaffPage,
  ActivityLogPage,
  ActivityLogDetailPage,
  AuditAlertsPage,
  AuditAlertDetailPage,
  EmailNotificationsPage,
  OrdersPage,
  ReturnsPage,
  DriversPage,
  CreateDriverPage,
  EditDriverPage,
  DriverInfoPage,
  DeliveryFeesPage,
  DeliveriesPage,
  DriverDeliveriesPage,
  ResellersPage,
  ResellerProfilePage,
  SharingSchedulePage,
  NotificationsPage,
  OffersPage,
  BannersPage,
  InternalBankPage,
  RefundsPage,
  TransactionsPage,
  InsightsPage,
  RecommendationsPage,
  ProductPriceInsightPage,
  ProfitAndLossPage,
  EarningsPage,
  BonusCouponsPage,
  SpendAndSaveCouponsPage,
  InfluencerCouponsPage,
  ProductSetsPage,
  PacksPage,
  PackInfoPage,
  PackPreviewPage,
  CompaniesPage,
  CompanyInfoPage,
  DeliveryPriorityPage,
  AIConversationsPage,
  SupportPage,
  AITicketsPage,
  AIReviewPage,
  AIAgentsPage,
  AIAgentDetailPage,
  WhatsAppAdProductsPage,
  MarketingPage,
  MarketingCampaignPage,
  MarketingFlowPage,
  CompanyAdminDashboardPage,
  CompanyAdminOrdersPage,
  CompanyAdminDriversPage,
  CompanyAdminSettingsPage,
  CompanyAdminStaffPage,
  CompanyAdminFinancialPage,
  CompanyAdminDriverDeliveriesPage
} from "pages/main";
import { Routes as AppRoutes, Navigate, Route } from "react-router-dom";

import {
  PrivateRoute,
  AuthRoute,
  PrivilegeChecker,
  ManagerPrivateRoute,
  ManagerAuthRoute
} from "./components";

const Routes = () => {
  return (
    <AppRoutes>
      <Route
        path="/login"
        element={
          <AuthRoute>
            <LoginPage />
          </AuthRoute>
        }
      />

      <Route
        path="/"
        element={
          <PrivateRoute>
            <MainLayout />
          </PrivateRoute>
        }
      >
        <Route
          index
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Dashboard}
            >
              <DashboardPage />
            </PrivilegeChecker>
          }
        />
        <Route path="/users">
          <Route index element={<Navigate to="/users/all" replace />} />
          <Route
            path="/users/:activeTab"
            element={
              <PrivilegeChecker
                necessaryPrivilege={ModeratorRoutesPrivileges.Resellers}
              >
                <ResellersPage />
              </PrivilegeChecker>
            }
          />
        </Route>

        <Route
          path="/users/:usersTab/:resellerId/:activeTab"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Resellers}
            >
              <ResellerProfilePage />
            </PrivilegeChecker>
          }
        />

        <Route
          path="/categories"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Categories}
            >
              <CategoriesPage />
            </PrivilegeChecker>
          }
        />
        {/* Guides sit under Content, not Categories — the same privilege the
            other Content screens use, matching what the API enforces. */}
        <Route
          path="/categories/usage-guide/:categoryId"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Content}
            >
              <CategoryUsageGuidePage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/products"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Products}
            >
              <ProductsPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/products/category"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Products}
            >
              <ProductCategoryPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/products/create/:subChildCategoryId"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Products}
            >
              <CreateProductPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/products/edit/:subChildCategoryId/:editableProductId"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Products}
            >
              <EditProductPage />
            </PrivilegeChecker>
          }
        />

        <Route
          path="/products/details/:subChildCategoryId/:productId/:productVariantId/:subPage?"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Products}
            >
              <ProductInfoPage />
            </PrivilegeChecker>
          }
        />

        <Route
          path="/offers"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.SpecialOffers}
            >
              <OffersPage />
            </PrivilegeChecker>
          }
        />

        <Route
          path="/banners"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Banners}
            >
              <BannersPage />
            </PrivilegeChecker>
          }
        />

        <Route
          path="/sharing"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.SharingSchedule}
            >
              <SharingSchedulePage />
            </PrivilegeChecker>
          }
        />

        <Route
          path="/bonus-coupons/:activeTab"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Coupons}
            >
              <BonusCouponsPage />
            </PrivilegeChecker>
          }
        />

        <Route path="/bonus-coupons">
          <Route
            index
            element={<Navigate to="/bonus-coupons/sharings" replace />}
          />
          <Route
            path="/bonus-coupons/:activeTab"
            element={
              <PrivilegeChecker
                necessaryPrivilege={ModeratorRoutesPrivileges.Coupons}
              >
                <BonusCouponsPage />
              </PrivilegeChecker>
            }
          />
        </Route>

        <Route
          path="/spend-and-save-coupons"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Coupons}
            >
              <SpendAndSaveCouponsPage />
            </PrivilegeChecker>
          }
        />

        <Route
          path="/influencer-coupons"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Coupons}
            >
              <InfluencerCouponsPage />
            </PrivilegeChecker>
          }
        />

        <Route
          path="/inventory/:activeTab"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Inventory}
            >
              <InventoryPage />
            </PrivilegeChecker>
          }
        />

        <Route path="/warehouse">
          <Route
            index
            element={<Navigate to="/warehouse/transfers" replace />}
          />
          <Route
            path="/warehouse/transfers"
            element={
              <PrivilegeChecker
                necessaryPrivilege={ModeratorRoutesPrivileges.Inventory}
              >
                <TransfersPage />
              </PrivilegeChecker>
            }
          />
          <Route
            path="/warehouse/transfers/:transferId"
            element={
              <PrivilegeChecker
                necessaryPrivilege={ModeratorRoutesPrivileges.Inventory}
              >
                <TransferDetailPage />
              </PrivilegeChecker>
            }
          />
        </Route>

        <Route
          path="/delivery-rules"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Drivers}
            >
              <DeliveryRulesPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/insights/:activeTab"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Insights}
            >
              <InsightsPage />
            </PrivilegeChecker>
          }
        />
        <Route path="/marketing">
          <Route
            index
            element={<Navigate to="/marketing/contacts" replace />}
          />
          <Route
            path="/marketing/campaigns/:campaignId"
            element={
              <PrivilegeChecker
                necessaryPrivilege={ModeratorRoutesPrivileges.Marketing}
              >
                <MarketingCampaignPage />
              </PrivilegeChecker>
            }
          />
          <Route
            path="/marketing/flows/:flowId"
            element={
              <PrivilegeChecker
                necessaryPrivilege={ModeratorRoutesPrivileges.Marketing}
              >
                <MarketingFlowPage />
              </PrivilegeChecker>
            }
          />
          <Route
            path="/marketing/:activeTab"
            element={
              <PrivilegeChecker
                necessaryPrivilege={ModeratorRoutesPrivileges.Marketing}
              >
                <MarketingPage />
              </PrivilegeChecker>
            }
          />
        </Route>
        <Route path="/recommendations">
          <Route
            index
            element={<Navigate to="/recommendations/affinity" replace />}
          />
          <Route
            path="/recommendations/:activeTab"
            element={
              <PrivilegeChecker
                necessaryPrivilege={ModeratorRoutesPrivileges.Products}
              >
                <RecommendationsPage />
              </PrivilegeChecker>
            }
          />
        </Route>
        <Route
          path="/insights/price-insights/:productId"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Insights}
            >
              <ProductPriceInsightPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/product-sets"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.ProductSets}
            >
              <ProductSetsPage />
            </PrivilegeChecker>
          }
        />

        <Route path="/earnings">
          <Route index element={<Navigate to="/earnings/Pending" replace />} />
          <Route
            path="/earnings/:activeTab"
            element={
              <PrivilegeChecker
                necessaryPrivilege={ModeratorRoutesPrivileges.Financial}
              >
                <EarningsPage />
              </PrivilegeChecker>
            }
          />
        </Route>
        <Route
          path="/delivery-fees/:activeTab"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Financial}
            >
              <DeliveryFeesPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/internal-bank"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Financial}
            >
              <InternalBankPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/deliveries"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Financial}
            >
              <DeliveriesPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/profit-and-loss"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Financial}
            >
              <ProfitAndLossPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/refunds"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Financial}
            >
              <RefundsPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/transactions"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Financial}
            >
              <TransactionsPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/deliveries/:driverId"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Financial}
            >
              <DriverDeliveriesPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/verification"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Verification}
            >
              <VerificationPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/notification"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Notification}
            >
              <NotificationsPage />
            </PrivilegeChecker>
          }
        />
        <Route path="/content">
          <Route index element={<Navigate to="/content/privacy" replace />} />
          <Route
            path="/content/:activeTab"
            element={
              <PrivilegeChecker
                necessaryPrivilege={ModeratorRoutesPrivileges.Content}
              >
                <ContentPage />
              </PrivilegeChecker>
            }
          />
        </Route>
        <Route
          path="/staff"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.StaffManagement}
            >
              <StaffPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/activity-log"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.ActivityLog}
            >
              <ActivityLogPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/activity-log/:auditLogId"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.ActivityLog}
            >
              <ActivityLogDetailPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/audit-alerts"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.CriticalAlerts}
            >
              <AuditAlertsPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/audit-alerts/:alertId"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.CriticalAlerts}
            >
              <AuditAlertDetailPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/email-notifications"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.EmailNotifications}
            >
              <EmailNotificationsPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/orders"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Orders}
            >
              <OrdersPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/returns/"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Returns}
            >
              <ReturnsPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/drivers"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Drivers}
            >
              <DriversPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/drivers/create"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Drivers}
            >
              <CreateDriverPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/drivers/edit/:editableDriverId"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Drivers}
            >
              <EditDriverPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/drivers/details/:driverId"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Drivers}
            >
              <DriverInfoPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/packs"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Products}
            >
              <PacksPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/packs/new"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Products}
            >
              <PackInfoPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/packs/:packId"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Products}
            >
              <PackPreviewPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/packs/:packId/edit"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Products}
            >
              <PackInfoPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/companies"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Drivers}
            >
              <CompaniesPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/companies/:companyId/:activeTab?"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Drivers}
            >
              <CompanyInfoPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/delivery-priority"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.Drivers}
            >
              <DeliveryPriorityPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/ai/conversations"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.AiAssistants}
            >
              <AIConversationsPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/ai/support"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.AiAssistants}
            >
              <SupportPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/ai/tickets"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.AiAssistants}
            >
              <AITicketsPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/ai/review"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.AiAssistants}
            >
              <AIReviewPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/ai/agents"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.AiAssistants}
            >
              <AIAgentsPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/ai/agents/:agentId"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.AiAssistants}
            >
              <AIAgentDetailPage />
            </PrivilegeChecker>
          }
        />
        <Route
          path="/ai/ad-products"
          element={
            <PrivilegeChecker
              necessaryPrivilege={ModeratorRoutesPrivileges.AiAssistants}
            >
              <WhatsAppAdProductsPage />
            </PrivilegeChecker>
          }
        />
        <Route path="/no-access" element={<NoAccessPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>

      <Route path="/company/login" element={<Navigate to="/login" replace />} />

      <Route
        path="/company"
        element={
          <ManagerPrivateRoute>
            <CompanyAdminLayout />
          </ManagerPrivateRoute>
        }
      >
        <Route index element={<CompanyAdminDashboardPage />} />
        <Route
          path="orders"
          element={<Navigate to="/company/orders/active" replace />}
        />
        <Route path="orders/:activeTab" element={<CompanyAdminOrdersPage />} />
        <Route path="drivers" element={<CompanyAdminDriversPage />} />
        <Route path="drivers/create" element={<CreateDriverPage />} />
        <Route
          path="drivers/edit/:editableDriverId"
          element={<EditDriverPage />}
        />
        <Route path="drivers/details/:driverId" element={<DriverInfoPage />} />
        <Route path="financial" element={<CompanyAdminFinancialPage />} />
        <Route
          path="financial/:driverId"
          element={<CompanyAdminDriverDeliveriesPage />}
        />
        <Route path="settings" element={<CompanyAdminSettingsPage />} />
        <Route path="staff" element={<CompanyAdminStaffPage />} />
      </Route>
    </AppRoutes>
  );
};

export default Routes;
